import React from "react";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
    label?: string;
}

export const RuleAccountNameAction: React.FC<Props> = ({
    value,
    label = "Assign cash ledger",
}) => <RuleTagRow label={label} type="action" values={[value]} />;
